import { useCallback, useEffect } from 'react';

import { useApiGet } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';
import { UserStudyFavorite } from '../../models/UserStudyFavorite';

export default function useGetStudyFavorites(userId: number) {
  const { data, isLoading, error, get, clearData } = useApiGet<
    Array<UserStudyFavorite>
  >(`users/${userId}/favorite`);

  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Get study favorite error', error)),
    [error, logError]
  );

  const getStudyFavorites = useCallback(() => get(), [get]);
  return {
    studyFavorites: data,
    studyFavoritesLoading: isLoading,
    studyFavoritesError: error,
    getStudyFavorites,
    clearData
  };
}
